<template>
    <div class="gridinbox">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:"AppGridInBox"
}

</script>

<style scoped>
.gridinbox:not(:last-child) {
    margin-bottom: 16px;
}
.gridinbox span {
    font-weight: bolder;
}
</style>
